import React from 'react';
import {
  LUCK_COLOR, LUCK_BG, HARM_COLOR, HARM_LABEL,
  HARM_STATE_COLOR, MEN_STATE_COLOR,
} from '../qimen/colors.js';
import { STARS, MENS, SHEN_LUCK, JIXING, RUMU } from '../qimen/constants.js';

const STAR_LUCK = Object.fromEntries(STARS.map(s => [s.name, s.luck]));
const MEN_BY = Object.fromEntries(MENS.map(m => [m.name, m]));

// 五行相克（门迫判定用）
const KE = (a, b) =>
  (a === '木' && b === '土') || (a === '土' && b === '水') ||
  (a === '水' && b === '火') || (a === '火' && b === '金') ||
  (a === '金' && b === '木');

// 干支四害状态 → 颜色：无四害黑 · 击刑红 · 入墓灰 · 刑+墓紫
function ganState(gan, gongNum) {
  if (!gan) return null;
  const xing = JIXING[gan] === gongNum;
  const mu = RUMU[gan] === gongNum;
  if (xing && mu) return { color: HARM_STATE_COLOR.xingmu, tip: `${gan}：击刑＋入墓（紫）` };
  if (xing) return { color: HARM_STATE_COLOR.xing, tip: `${gan}：击刑（红）` };
  if (mu) return { color: HARM_STATE_COLOR.mu, tip: `${gan}：入墓（灰）` };
  return { color: HARM_STATE_COLOR.none, tip: `${gan}：无四害（黑）` };
}

function Pill({ kind, text, title, className = '' }) {
  const luck = kind === 'star' ? STAR_LUCK[text] : SHEN_LUCK[text];
  const c = LUCK_COLOR[luck] || LUCK_COLOR['平'];
  return (
    <span className={`pill ${className}`} style={{ color: c, background: LUCK_BG[luck], borderColor: c }} title={title}>
      {text}
    </span>
  );
}

export default function PalaceCell({ p, onSelect }) {
  const harms = p.harms || [];
  // 只取时空亡（日空不显示）
  const shiKong = harms.find(h => h.type === '空亡' && h.label === '时空');
  const badges = [...new Map(
    harms.filter(h => h.type !== '空亡').map(h => [h.label + h.type, h])
  ).values()];
  // 门迫：门克宫 → 红色，否则黑
  const menPo = p.men && MEN_BY[p.men] && KE(MEN_BY[p.men].wx, p.wx);

  if (p.center) {
    return (
      <div className="cell center-cell" style={{ borderColor: '#9c6b3f' }}>
        <div className="gong-tag">
          <span className="gong-num">中五宫</span>
          {p.shen ? (
            <span className="gong-gua" style={{ color: '#8a6fc0' }}>{p.shen}</span>
          ) : (
            <span className="gong-gua">中</span>
          )}
        </div>
        <div className="center-body">
          <div className="gan-area">
            <span className="gan-row">{p.dipan}</span>
          </div>
          {p.shen ? (
            <div className="center-note">太常居中<br />（九神盘）</div>
          ) : (
            <div className="center-note">天禽寄坤二<br />随天芮同行</div>
          )}
        </div>
      </div>
    );
  }

  const diGans = [p.dipan, p.jigongDiGan].filter(Boolean);

  return (
    <button
      type="button"
      className={`cell ${p.isZhiFu ? 'is-zhifu' : ''} ${p.isZhiShi ? 'is-zhishi' : ''} ${shiKong ? ' is-kong' : ''}`}
      onClick={() => onSelect(p)}
      title="点击查看宫位详情"
    >

      {/* 顶部：值符/值使 + 神盘 + 时空亡小圆 + 宫位号 */}
      <div className="row row-shen">
        {(p.isZhiFu || p.isZhiShi) && (
          <span className="corner-marks">
            {p.isZhiFu && <i className="mark mark-fu">符</i>}
            {p.isZhiShi && <i className="mark mark-shi">使</i>}
          </span>
        )}
        <Pill kind="shen" text={p.shen} title="八神（神盘）" />
        {shiKong && (
          <span className="kong-dot" title={`【时空亡】${shiKong.detail}`} />
        )}
        <span className="gong-tag">
          <b className="gong-num">{p.num}</b>
          <span className="gong-gua">{p.gua}</span>
          <span className="gong-dir">{p.dir}</span>
        </span>
      </div>

      {/* 主区：左＝星 · 中＝门 · 右＝天干／地支（同大小，颜色示四害） */}
      <div className="pal-main">
        <div className="col-star" title="九星（天盘）">
          {p.stars.map((s, i) => <Pill key={i} kind="star" text={s} className="star-pill" />)}
        </div>

        <div className="col-men" title={menPo ? '八门（人盘）· 门迫' : '八门（人盘）'}>
          {p.men && (
            <b className="men-char" style={{ color: menPo ? MEN_STATE_COLOR.po : MEN_STATE_COLOR.none }}>
              {p.men.replace('门', '')}
            </b>
          )}
        </div>

        <div className="col-gan">
          <b className="gan-row" title="天盘干（颜色示四害：黑无·红刑·灰墓·紫刑墓）">
            {p.tianpan.map((g, i) => {
              const st = ganState(g, p.num);
              return <span key={i} style={{ color: st.color }}>{g}</span>;
            })}
          </b>
          <b className="gan-row" title="地盘干（寄宫时显两字；颜色示四害）">
            {diGans.map((g, i) => {
              const st = ganState(g, p.num);
              return <span key={i} style={{ color: st.color }}>{g}</span>;
            })}
          </b>
        </div>
      </div>

      {/* 底部：四害徽标（迫刑墓）+ 马星 */}
      {(badges.length > 0 || p.isMa) && (
        <div className="badge-row">
          {badges.map((h, i) => (
            <span key={i} className="harm-badge" style={{ background: HARM_COLOR[h.type] }}
              title={`${HARM_LABEL[h.type]} · ${h.detail}`}>
              {HARM_LABEL[h.type]}
            </span>
          ))}
          {p.isMa && <span className="ma-badge" title={`驿马临此宫`}>马</span>}
        </div>
      )}
    </button>
  );
}
